@if (parentFormGroup &&
  parentFormGroup.controls &&
  parentFormGroup.controls[this.controlName]) {
  <div
    [formGroup]="parentFormGroup"
    class="flex flex-row justify-start items-center"
    >
    <mat-checkbox
      [color]="'primary'"
      [disabled]="isDisabled"
      [formControlName]="controlName"
      aria-label="Select an option"
      class="checkbox {{error ? 'error':''}} {{this.type}}"
      >
      {{ label }}
    </mat-checkbox>
  </div>
}
@if (error) {
  <div
    class="form-field-error justify-start"
    >
    {{ error }}
  </div>
}
